import React from 'react';
import HeroSkeleton from './HeroSkeleton';
import AboutMeSkeleton from './AboutMeSkeleton';
import InfoSkeleton from './InfoSkeleton';
import WorkFormatsSkeleton from './WorkFormatsSkeleton';
import PartnersSkeleton from './PartnersSkeleton';
import ContactSkeleton from './ContactSkeleton';

const MainPageSkeleton: React.FC = () => {
    return (
        <>
            <HeroSkeleton />
            <main className="content-wrapper">
                <AboutMeSkeleton />
                <InfoSkeleton />
                <WorkFormatsSkeleton />
                <PartnersSkeleton />
                <ContactSkeleton />
            </main>
        </>
    );
};

export default MainPageSkeleton;
